module.exports = __webpack_public_path__ + "static/media/auth-manage-icon-ekb.4c5acbd49e21e0445f6681a5fa3af318.svg";